/* eslint-disable */
import React from "react";
import logo from "../../assets/images/jayveer-logo.png";
import facebook from "../../assets/images/svg/facebook.svg";
import twitter from "../../assets/images/svg/twitter.svg";
import google from "../../assets/images/svg/google.svg";
import insta from "../../assets/images/insta.svg";
import { useEffect } from "react";
import { BsArrowUpShort } from "react-icons/bs";
import "./Footer.scss";

const Footer = () => {
  useEffect(() => {
    if (window !== undefined) {
      let backtotop = document.getElementById("btn-go-to-top");
      const toggleBacktotop = () => {
        if (window.scrollY > 100) {
          backtotop.classList.add("active");
        } else {
          backtotop.classList.remove("active");
        }
      };
      window.addEventListener("load", toggleBacktotop);
      document.addEventListener("scroll", toggleBacktotop);
    }
  }, []);

  return (
    <>
      <footer id="footer" className="footer">
        <div className="footer-top as_footer_inner as_padderTop50 as_padderBottom35">
          <div className="container">
            <div className="row gy-4 ">
              <div className=" col-xl-3  col-12 footer-info logoaddress">
                <a href="#" className=" d-flex align-items-center address ">
                  <img src={logo} alt="" width={200} className="imglogo"  />
                </a>
                <p>
                  131, Nathubhai Tower, <br /> Opposite of Maruti suzuki
                  showroom,
                  <br /> Udhna main road,
                  <br /> Surat, Gujarat, India-394210
                </p>
              </div>

              <div className="  col-xl-3 col-sm-4 col-6  as_footer_widget usefullinks">
                <h4 className="as_footer_heading as_heading_center">
                  Useful Links
                </h4>
                <ul>
                  <li>
                    <i className="bi bi-chevron-right"></i> <a href="#home">Home</a>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href="#service">Services</a>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href="#aboutus">About us</a>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href="#appointment">Appointment</a>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href="#aboutus">Contact</a>
                  </li>
                </ul>
              </div>
              <div className="  col-xl-3 col-sm-4 col-6 as_footer_widget usefullinks">
                <h4 className="as_footer_heading as_heading_center">
                  Our Services
                </h4>
                <ul>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href="#aboutus">Janam Kundli</a>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href="#aboutus">Kundli Dosh</a>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href="#aboutus">Grah Shanti</a>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href="#aboutus">Vastu Puja</a>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href="#aboutus">Marriage</a>
                  </li>
                </ul>
              </div>

              <div className="  col-xl-3 col-sm-4 col-12 footer-info followus  ">
                <h1 className="as_footer_heading as_heading_center foloowusfont">
                  Follow Us
                </h1>
                <div className="as_share_box">
                  <ul className="ul">
                    <a href="javascript:;">
                      <img src={facebook} alt="" style={{ width: "36px" }} />
                    </a>
                    <a href="javascript:;">
                      <img src={twitter} alt="" style={{ width: "39px" }} />
                    </a>
                    <a href="javascript:;">
                      <img src={google} alt="" style={{ width: "29px" }} />
                    </a>
                    <a href="javascript:;">
                      <img src={insta} alt="" style={{ width: "50px" }} />
                    </a>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="container">
          <div
            className="copyright"
            style={{ textAlign: "center", margin: "20px 0" }}
          >
            &copy; Copyright{" "}
            <strong>
              <span style={{ color: "#ff7010" }}>Jayveer Jyotish</span>
            </strong>
            . All Rights Reserved
          </div>
        </div>
      </footer>
      <a
        id="btn-go-to-top"
        href="#home"
        className="back-to-top d-flex align-items-center justify-content-center"
      >
        <i>
          <BsArrowUpShort />
        </i>
      </a>
    </>
  );
};

export default Footer;
